import { IVec3 } from '@stair-craft/common/util';

// Sawtooth point generator for a flight running along ±X (L/U flight 2).
// `direction` is +1 for +X (right turn), -1 for -X (left turn).
export function buildFlightSawtoothX(
    stepCount: number,
    treadDepth: number,
    startX: number,
    direction: 1 | -1,
    z: number,
    entryY: number,
    exitY: number,
    riserHeight: number
): IVec3[] {
    const points: IVec3[] = [{ x: startX, y: entryY, z }];
    for (let j: number = 0; j < stepCount; j++) {
        const xFront: number = startX + direction * j * treadDepth;
        const xBack: number = startX + direction * (j + 1) * treadDepth;
        const stepY: number = entryY + (j + 1) * riserHeight;
        points.push({ x: xFront, y: stepY, z });
        points.push({ x: xBack, y: stepY, z });
    }
    points.push({ x: startX + direction * stepCount * treadDepth, y: exitY, z });
    return points;
}
